import RouterView from '@/components/RouterView'
import Kelonlist from './KelonList.vue'
import KelonVideoPlayer from './KelonVideoPlayer.vue'

export default [
    {
        path: 'kelon',
        component: RouterView,
        children: [
            {
                path: '',
                component: Kelonlist,
                name: 'kelon',
                meta: { title: 'Kelon' },
            },
            { path: ':hash', component: KelonVideoPlayer, name: 'kelon.play' },
        ],
    },
]
